var SupportChannelType;
(function (SupportChannelType) {
    SupportChannelType["TELEGRAM"] = "telegram";
    SupportChannelType["PHONE"] = "phone";
    SupportChannelType["EMAIL"] = "email";
    SupportChannelType["WHATSAPP"] = "whatsapp";
})(SupportChannelType || (SupportChannelType = {}));

export { SupportChannelType };
//# sourceMappingURL=Support.types.js.map
